export const environment = {
    production: false,
    apiUrl: "https://dev-smp-eu-west-1.service.3ddigitalvenue.com/tmp",
    isOpenhouse: false,
    routes: true,
};
